import React from 'react';
import styled from 'styled-components';

import Box from 'components/shared/Box';

interface ErrorBoxProps {
  errorMessage: string;
  children?: React.ReactNode;
}

const ErrorBoxHeader = styled.div`
  font-family: 'CircularStd-Bold';
  font-size: 60px;
  color: #1d4ed8;
`;

const ErrorBoxBody = styled.div`
  font-family: 'CircularStd-Medium';
  font-size: 20px;

  text-align: center;
`;

const ErrorBox: React.FC<ErrorBoxProps> = ({ errorMessage, children }) => {
  return (
    <Box alignItems="center">
      <ErrorBoxHeader>&#128532;</ErrorBoxHeader>
      <ErrorBoxBody>{errorMessage}</ErrorBoxBody>
      {children}
    </Box>
  );
};

export default ErrorBox;
